import React from 'react';
import { Navigate } from 'react-router-dom';
import LoadingSpinner from '../../components/LoadingSpinner';
import useEmailFollowUpEnabled from '../../hooks/useEmailFollowUpEnabled';
import ReceivedEmails from './ReceivedEmails';
import { useAuth } from '../../AuthContext';

const ReceivedEmailsProtected: React.FC = () => {
  const { emailFollowUpEnabled, loading } = useEmailFollowUpEnabled();
  const { viewingAllAccounts } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  // If viewing all accounts, always allow access
  if (viewingAllAccounts) {
    return <ReceivedEmails />;
  }

  // If email follow-up is not enabled for specific account, redirect to follow-up messages setup
  if (!emailFollowUpEnabled) {
    return <Navigate to="/follow-up-messages" replace />;
  }

  // Email follow-up is enabled, show the received emails
  return <ReceivedEmails />;
};

export default ReceivedEmailsProtected;